/**
 * @format
 */

import axios from 'axios';
import { UserData } from '../types/users.types';

const apiUrl = process.env.REACT_APP_SIADASH_BACKEND_URL;

class UsersService {
  /**
   * Fetch all users
   */
  async getAllUsers(): Promise<UserData[]> {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axios.get<UserData[]>(
        `${apiUrl}/api/super-admin/users`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error: any) {
      console.error('Error fetching all users:', error);
      throw error.response?.data || error;
    }
  }

  /**
   * Fetch users by office
   */
  async getUsersByOffice(officeId: string): Promise<UserData[]> {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axios.get<UserData[]>(
        `${apiUrl}/api/users/byOffice/${officeId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error: any) {
      console.error('Error fetching office users:', error);
      throw error.response?.data || error;
    }
  }

  /**
   * Fetch users with no office
   */
  async getUsersWithNoOffice(): Promise<UserData[]> {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axios.get<UserData[]>(
        `${apiUrl}/api/super-admin/users/no-office`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error: any) {
      console.error('Error fetching users with no office:', error);
      throw error.response?.data || error;
    }
  }

  /**
   * Search users by name or email
   */
  async searchUsers(query: string): Promise<UserData[]> {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axios.get<UserData[]>(
        `${apiUrl}/api/users/search`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: { query },
        }
      );
      return response.data;
    } catch (error: any) {
      console.error('Error searching users:', error);
      throw error.response?.data || error;
    }
  }
}

export const usersService = new UsersService();
